import scss from "refractor/scss";
export default scss;